module.exports = __webpack_public_path__ + "static/media/podcast_logo.b5253c5c.png";